var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'arabic-layout': _vm.isArabic },attrs:{"id":"app","data-theme":_vm.isIslamic}},[_c('navigation',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }